<template>
  <el-form-item
    :label="form.name"
    :prop="form.model"
    :class="[form.options.required?'label-blue':'']"
    :rules="form.rules"
    :required="form.options.required"
    v-show="!form.options.hidden"
    style="padding-left:10px;line-height:36px;"
  >
    
    <el-select style="width:226px" :disabled="inputDisable" v-model="value[form.model]" filterable :filter-method="filterSelect" @focus="getPro"  :placeholder="form.options.placeholder" @clear="clear" ref="selectReport" clearable>
    <el-option  :label="value[form.model]" :value="value[form.model]" style="width: 380px;height:auto;background-color:#fff;padding: 0px;">
     <el-tree
     ref="tree"
      style="width:100%;"
      :data="optionData"
     :filter-node-method="filterNode"
      node-key="id"
      :props="{label:'project',children:form.options.props.children}"
        @node-click="nodeClick">
        <span class="custom-tree-node" slot-scope="{node,data}">
        <span v-if="data.unit!=null">{{data.project+'   ('+data.unit+')'}}</span>
        <span v-else>{{data.project}}</span>
      </span>
    </el-tree>
    </el-option>
  </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: "ProjectTree",
  // components: {},,expandTrigger:'hover' this.$refs.org.dropDownVisible=false;
  data() {
    return {
      loading: false,
      key: "",
      mainValue: [],
      formData: { value: "" },
      optionData: [],
      remoteSearchFunc: () => {},
      dialogVisible: false,
      filterText: "",
      showPop:true,
      nowValue:'',
    };
  },
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          name: "",
          prop: "",
          icon: "",
          className: "",
          options: {
            defaultValue: [],
            width: "",
            placeholder: "",
            disabled: false,
            clearable: false,
            remote: true,
            remoteOptions: [],
            props: {
              value: "value",
              label: "label",
              children: "children"
            },
            customClass: "",
            labelWidth: 100,
            isLabelWidth: false,
            hidden: false,
            dataBind: true, 
            showLast: false,
            remoteFunc: () => {},
            remoteSearch: false,
            remoteSearchFunc: () => {}
          },
          key: "",
          model: "value",
          modelLabel: [],
          postData:{},
          selectData:[],
          department: false,
          rules: [{}]
        };
      }
    },
    value: Object,
    forms: {
      type: Object,
      default: () => {
        return {};
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    value: {
      immediate: true,
      handler(val) {
        this.mainValue = val;

      }
    },
    "form.options.remoteOptions": function(newVal, oldVal) {
      this.optionData = newVal;
    },
  },
  methods: {
    filterSelect(value){
      this.filterText = value
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.project.indexOf(value) !== -1;
    },
    getPro() {
      this.optionData=this.form.selectData;
    },
    //节点被点击
    nodeClick(data, checked, event) {
      if(data.children.length>0){}else{
        this.value[this.form.model] = data.project;
        let lists=this.form.modelLabel;
        lists.forEach(element => {
            let bs=element.split(",");
            this.value[bs[0]]=data[bs[1]];
        });
        this.$refs.selectReport.blur()
      }
        
    },
    yes() {
      this.dialogVisible = false;
    },
    clear(){
         this.value[this.form.model] = "";
          let lists=this.form.modelLabel;
          lists.forEach(element => {
              let bs=element.split(",");
              this.value[bs[0]]="";
          });
         this.filterText = ""
    },
    treeShow(){
        this.dialogVisible=true
        this.$emit('popoverShow',this.dialogVisible)
    }
  },
  created() {
    if (this.form.department === undefined) {
      this.form.department = false;
    }
  },
  mounted() {
    let that = this;
    that.$emit("init", that.key, that);
    setInterval(function() {
      document.querySelectorAll(".el-cascader-node__label").forEach(el => {
        el.onclick = function() {
          if (this.previousElementSibling) this.previousElementSibling.click();
        };
      });
    }, 1000);
  },
  computed: {
    inputDisable() {
      return this.disabled || this.form.options.disabled;
    }
  }
};
</script>

<style scoped>
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/DynamicPages/Customize/ProjectTree.vue"
}
</vue-filename-injector>
